import { lazy } from "react"
import Layout from "./layout"
import Home from "./pages/Home"

const Promotion = lazy(() =>
  import(/* webpackPrefetch: true */ "./pages/Promotion")
)
const Claims = lazy(() => import(/* webpackPrefetch: true */ "./pages/Claims"))
const MyPrize = lazy(() =>
  import(/* webpackPrefetch: true */ "./pages/MyPrize")
)
const MyStatus = lazy(() =>
  import(/* webpackPrefetch: true */ "./pages/MyStatus")
)

export default [
  {
    path: "/",
    component: Layout,
    routes: [
      {
        path: "/",
        component: Home,
        exact: true,
        key: "home",
      },
      {
        path: "/promotion",
        component: Promotion,
        exact: true,
        key: "promotion",
      },
      {
        path: "/claims",
        component: Claims,
        exact: true,
        key: "claims",
      },
      {
        path: "/myprize",
        component: MyPrize,
        exact: true,
        key: "myprize",
      },
      {
        path: "/mystatus",
        component: MyStatus,
        exact: true,
        key: "mystatus",
      },
    ],
  },
]
